export enum ContextTokenTypeEnum {
  ConfirmEmail = 'confirm-email',
  SendConfirmEmail = 'send-confirm-email',
  ResetPassword = 'reset-password',
  SetStatusAuctionOffer = 'set-status-auction-offer'
}
